import { useEffect, useState } from 'react';

import classNames from 'classnames';
import BaseStyling from 'config/baseStyling';
import styled from 'styled-components';

import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';

import { Icon } from '@sdb/planning-ui';

const StyledDialog = styled(Dialog)`
  height: 100%;
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 18px;
  }

  .MuiDialogContent-root {
    flex-grow: 1;
  }

  .MuiDialogActions-root {
    padding: 20px 0 0;
  }
`;

type Props = DialogProps & {
  hideTitle?: boolean;
  open: boolean;
  title?: string | React.ReactNode;
  headerBgColor?: string;
  hideCloseButton?: true;
  disableBackdropClick?: true;
  onHidden?: () => void;
  handleClose?: () => void;
};

export default function CustomDialog(props: Props) {
  const {
    hideTitle = false,
    open = true,
    onHidden,
    children,
    title = '',
    headerBgColor = '',
    hideCloseButton,
    handleClose,
    disableBackdropClick,
    ...rest
  } = props;
  const [isClosed, setClosed] = useState(false);

  const onClose = () => {
    if (handleClose) {
      handleClose();
    } else {
      setClosed(true);
    }
  };

  useEffect(() => {
    if (!open) {
      setClosed(false);
    }
  }, [open]);

  return (
    <StyledDialog
      onClose={disableBackdropClick ? undefined : onClose}
      TransitionProps={{ onExited: onHidden }}
      open={isClosed ? false : open}
      {...rest}
    >
      {!hideTitle && (
        <DialogTitle
          className={classNames('d-flex', 'center', title ? 'between' : 'end')}
          style={headerBgColor ? { backgroundColor: headerBgColor } : undefined}
        >
          {title && (
            <span style={headerBgColor ? { color: 'white' } : undefined}>
              {title}
            </span>
          )}
          {!hideCloseButton && (
            <IconButton
              aria-label="close"
              onClick={onClose}
              style={{ marginLeft: '10px' }}
              size="large"
            >
              <Icon
                type="xmark"
                style={headerBgColor ? { color: 'white' } : undefined}
              />
            </IconButton>
          )}
        </DialogTitle>
      )}

      <DialogContent dividers>
        <BaseStyling>{children}</BaseStyling>
      </DialogContent>
    </StyledDialog>
  );
}
